import styled from 'styled-components';
import { Typography } from 'antd';
import { font } from 'shared/utils/styles';

const { Title } = Typography;
export const StyledHeaderTextModal = styled(Title)`
  ${font.bold}
  margin-bottom: 0px !important;
`;

export const StyledSubTitleTextModal = styled.small`
  color: #666666;
`;
